export default __webpack_public_path__ + "static/media/Pin-Error.fbbcc612.svg";